// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"734a6bb0","189":"69c5a58c","254":"97b0d2b7","281":"63d8e13d","425":"6a70a9b6","444":"3fb203c4","447":"f9092f9c","568":"2ecc5377","845":"c42cbd72","885":"e7876483"}[chunkId] + ".chunk.js";
};